<template>
  <div class="mobile-a-page" @click="pageClick">
    <div class="ma-stage">
      <div class="ma-hero-wrap">
        <div class="ma-hero-glow-box">
          <img class="ma-hero-glow" :src="hero" alt="" />
        </div>
        <img class="ma-hero" :src="hero" alt="" />
      </div>
      <div class="ma-title-wrap">
        <img class="ma-title" :src="title" alt="" />
        <div class="ma-subtitle">你的全彩成人漫画专属站</div>
      </div>
      <img class="ma-cards" :src="cards" alt="" />

      <img class="ma-logo" :src="logo" alt="妖精漫画" />
      <div class="ma-contacts">
        <button
          v-for="item in contactItems"
          :key="item.type"
          class="ma-contact"
          type="button"
          :aria-label="item.label"
          @click.stop="jumpUrl(item.url)"
        >
          <span class="ma-contact-inner">
            <img
              class="ma-contact-icon"
              :class="item.type"
              :src="item.icon"
              alt=""
            />
            <span>{{ item.label }}</span>
          </span>
        </button>
      </div>
    </div>
    <div class="ma-footer">
      <div class="ma-downloads">
        <button
          v-if="isIos"
          class="ma-download"
          type="button"
          aria-label="iOS下载"
          @click.stop="downloadByType('ios', $event)"
        >
          <img :src="iosBtn" alt="iOS下载" />
        </button>
        <button
          v-else
          class="ma-download"
          type="button"
          aria-label="安卓下载"
          @click.stop="downloadByType('android', $event)"
        >
          <img :src="androidBtn" alt="安卓下载" />
        </button>
      </div>
      <div class="ma-ai-text">AI短剧全新上线</div>
      <div class="ma-tip">
        <span
          >提示：本APP属于特殊行业，偶尔会误报毒提醒，如有报毒提示，请点击忽略，并开启飞行模式安装即可！</span
        >
      </div>
    </div>

    <van-overlay :show="androidPromptShow" z-index="999" class="androidOverlay">
      <div class="overlayContent" @click.stop>
        <div class="confirmBtnBox" @click="androidPromptShow = false"></div>
      </div>
    </van-overlay>
    <van-overlay :show="iosPromptShow" z-index="999" class="iosOverlay">
      <div class="overlayContent" @click.stop>
        <div class="confirmBtnBox" @click="iosPromptShow = false"></div>
      </div>
    </van-overlay>
    <van-popup v-model="showTip" class="downTip">
      <div class="downTipTitle">温馨提示</div>
      <div class="downTipContent">请使用Safari浏览器进行下载</div>
      <div class="url">{{ currUrl }}</div>
      <div class="downTipConfirm" @click.stop="doCopy">复制链接</div>
    </van-popup>
  </div>
</template>

<script>
import { landingPageClick } from "@/utils/eventTracker";
import Hero from "@/assets/images/mobile1/a/hero.png";
import Title from "@/assets/images/mobile1/a/title.png";
import Cards from "@/assets/images/mobile1/a/cards.png";
import Logo from "@/assets/images/mobile1/a/logo.png";
import AndroidBtn from "@/assets/images/mobile1/a/android-download.png";
import IosBtn from "@/assets/images/mobile1/a/ios-download.png";
import IconGroup from "@/assets/images/mobile1/a/icon-group.png";
import IconBusiness from "@/assets/images/mobile1/a/icon-business.png";
import IconChannel from "@/assets/images/mobile1/a/icon-channel.png";

export default {
  props: ["os", "configs", "switchData", "version"],
  data() {
    return {
      androidPromptShow: false,
      iosPromptShow: false,
      showTip: false,
      autoDownloadTriggered: false,
      currUrl: window.location.href,
      cTg: "",
      cPotato: "",
      cBusiness: "",
      cChannel: "",
      hero: Hero,
      title: Title,
      cards: Cards,
      logo: Logo,
      androidBtn: AndroidBtn,
      iosBtn: IosBtn,
      iconGroup: IconGroup,
      iconBusiness: IconBusiness,
      iconChannel: IconChannel
    };
  },
  computed: {
    isIos() {
      return !!(this.os && this.os.isPhone);
    },
    contactItems() {
      return [
        {
          type: "group",
          label: "官方群组",
          url: this.cTg,
          icon: this.iconGroup
        },
        {
          type: "business",
          label: "商务合作",
          url: this.cBusiness,
          icon: this.iconBusiness
        },
        {
          type: "channel",
          label: "渠道合作",
          url: this.cChannel,
          icon: this.iconChannel
        }
      ];
    }
  },
  watch: {
    configs: {
      immediate: true,
      handler(configs = []) {
        this.cTg = "";
        this.cPotato = "";
        this.cBusiness = "";
        this.cChannel = "";
        configs.forEach(item => {
          if (item.configType === "tg_group") {
            this.cTg = item.link;
          } else if (item.configType === "potato_group") {
            this.cPotato = item.link;
          } else if (item.configType === "sw_cooperate") {
            this.cBusiness = item.link;
          } else if (item.configType === "qd_cooperate") {
            this.cChannel = item.link;
          }
        });
      }
    },
    switchData: {
      immediate: true,
      handler() {
        this.tryAutoDownload();
      }
    }
  },
  mounted() {
    if (!this.checkIsSafari() && this.os.isPhone) {
      this.showTip = true;
    }
  },
  methods: {
    pageClick(event) {
      landingPageClick(this, {
        click_coordinates_x: event.clientX,
        click_coordinates_y: event.clientY
      });
    },
    doCopy() {
      this.$copyText(this.currUrl).then(
        () => {
          this.showTip = false;
        },
        () => undefined
      );
    },
    checkIsSafari() {
      const ua = ((this.os && this.os.userAgent) || "").toLowerCase();
      // iOS 三方浏览器（Chrome/Firefox/Edge/Opera/夸克）UA 也带 Safari，需排除
      return (
        ua.indexOf("safari") !== -1 &&
        ua.indexOf("browser") === -1 &&
        ua.indexOf("android") === -1 &&
        ua.indexOf("crios") === -1 &&
        ua.indexOf("fxios") === -1 &&
        ua.indexOf("edgios") === -1 &&
        ua.indexOf("opios") === -1 &&
        ua.indexOf("quark") === -1
      );
    },
    // 下载数据就绪后，按当前系统自动触发一次下载
    tryAutoDownload() {
      if (this.autoDownloadTriggered) return;
      // 仅落地页带渠道码 ?dc=xxx 时才自动下载
      if (!this.$route.query.dc) return;
      const data = this.switchData || {};
      const isIos = this.os && this.os.isPhone;
      // 安卓仅在渠道包地址存在时才自动下载
      const downUrl = isIos ? data.iosDownUrl : data.channelApkAndDownUrl;
      if (!downUrl) return;
      // iOS 非 Safari 浏览器无法下载，已弹 Safari 提示，不自动触发
      if (isIos && !this.checkIsSafari()) return;
      this.autoDownloadTriggered = true;
      this.fireWhenPageLoaded(() => {
        // 下载立即触发，安装教程弹窗延迟 5s 再弹出
        this.downloadByType(isIos ? "ios" : "android", null, 5000);
      });
    },
    // 等页面资源加载完成再执行，避免下载跳转把加载中的图片全部中断
    fireWhenPageLoaded(fn) {
      if (document.readyState === "complete") {
        fn();
        return;
      }
      let fired = false;
      const fire = () => {
        if (fired) return;
        fired = true;
        window.removeEventListener("load", fire);
        fn();
      };
      window.addEventListener("load", fire);
      // 兜底：弱网下资源迟迟加载不完也要触发下载
      setTimeout(fire, 10000);
    },
    async showInstallTutorial(type) {
      if (type === "ios") {
        this.iosPromptShow = true;
      } else {
        this.androidPromptShow = true;
      }
    },
    async downloadByType(type, event, tutorialDelay = 0) {
      this.$toast("应用正在下载中，十秒后无反应请再次点击下载！");
      this.$emit("getApkInfoApi", type);
      if (tutorialDelay) {
        setTimeout(() => {
          this.showInstallTutorial(type);
        }, tutorialDelay);
      } else {
        await this.showInstallTutorial(type);
      }
      setTimeout(() => {
        this.$emit("getApkInfo", type);
      }, 500);
      // 上报点击（下载按钮）；自动触发时无点击事件，不上报
      if (!event) return;
      landingPageClick(this, {
        tab_name: "下载按钮",
        tab_key: "download",
        click_coordinates_x: event.clientX,
        click_coordinates_y: event.clientY
      });
    },
    jumpUrl(url) {
      if (!url) return;
      window.open(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.mobile-a-page {
  background: #d8d6f4 url("../../../assets/images/mobile1/a/bg.png") no-repeat
    center top;
  background-size: cover;
  box-sizing: border-box;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: calc(150px + env(safe-area-inset-bottom));
  position: relative;
  width: 100%;

  .ma-stage {
    height: 661px;
    position: relative;
    width: 100%;
  }

  .ma-hero-wrap,
  .ma-title-wrap,
  .ma-cards,
  .ma-logo {
    display: block;
    pointer-events: none;
    position: absolute;
  }

  .ma-hero-wrap {
    height: 502px;
    left: 42px;
    overflow: visible;
    top: 0;
    width: 282px;
    z-index: 2;
  }

  .ma-hero {
    display: block;
    height: 502px;
    left: 0;
    object-fit: contain;
    position: absolute;
    top: 0;
    width: 282px;
    z-index: 2;
  }

  .ma-hero-glow-box {
    -webkit-filter: blur(44.26Px);
    filter: blur(44.26Px);
    height: 602Px;
    left: -50Px;
    opacity: 0.3;
    overflow: visible;
    position: absolute;
    top: -50Px;
    width: 382Px;
    z-index: 1;
  }

  .ma-hero-glow {
    display: block;
    height: 502px;
    left: 50Px;
    object-fit: contain;
    position: absolute;
    top: 50Px;
    width: 282px;
  }

  .ma-title-wrap {
    height: 224px;
    left: 4.75px;
    top: 274px;
    width: 365.5px;
    z-index: 4;
  }

  .ma-title {
    display: block;
    height: 100%;
    left: 0;
    object-fit: contain;
    position: absolute;
    top: 0;
    width: 100%;
  }

  .ma-subtitle {
    bottom: 43px;
    color: rgba(26, 27, 114, 1);
    font-family: "PingFang SC", "Hiragino Sans GB", sans-serif;
    font-size: 15px;
    font-weight: 500;
    left: 50%;
    line-height: 1;
    position: absolute;
    transform: translateX(-50%);
    white-space: nowrap;
    z-index: 5;
  }

  .ma-cards {
    height: 200px;
    left: 38px;
    object-fit: contain;
    top: 461px;
    width: 300px;
    z-index: 5;
  }

  .ma-logo {
    height: 36px;
    left: 9px;
    object-fit: contain;
    top: calc(14px + env(safe-area-inset-top));
    width: 100px;
    z-index: 30;
  }

  .ma-contacts {
    display: flex;
    flex-wrap: nowrap;
    gap: 13px;
    position: absolute;
    right: 6px;
    top: calc(21px + env(safe-area-inset-top));
    z-index: 30;
  }

  .ma-contact {
    appearance: none;
    background: linear-gradient(180deg, #b64ed6 0%, #5152db 50%, #50b9ff 100%);
    border: 0;
    border-radius: 11px;
    box-sizing: border-box;
    color: rgba(255, 255, 255, 1);
    cursor: pointer;
    flex-shrink: 0;
    height: 22px;
    overflow: hidden;
    padding: 0;
    position: relative;
    width: 55px;
    -webkit-tap-highlight-color: transparent;
  }

  .ma-contact-inner {
    align-items: center;
    display: flex;
    font-size: 12px;
    justify-content: center;
    left: 50%;
    line-height: 1;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%) scale(0.58333);
    white-space: nowrap;
  }

  .ma-contact-icon {
    display: block;
    filter: brightness(0) invert(1);
    flex-shrink: 0;
    margin-right: 6.86px;
    object-fit: contain;

    &.group {
      height: 20.57px;
      width: 23.14px;
    }

    &.business {
      height: 25.71px;
      width: 28.29px;
    }

    &.channel {
      height: 24px;
      width: 24px;
    }
  }

  .ma-footer {
    bottom: 0;
    left: 0;
    padding-bottom: env(safe-area-inset-bottom);
    padding-top: 20px;
    position: fixed;
    right: 0;
    z-index: 20;
  }

  .ma-downloads {
    display: flex;
    gap: 16px;
    justify-content: center;
    margin-bottom: 28px;
  }

  .ma-download {
    appearance: none;
    background: transparent;
    border: 0;
    cursor: pointer;
    height: 45.5px;
    padding: 0;
    width: 135.5px;
    -webkit-tap-highlight-color: transparent;

    img {
      display: block;
      height: 100%;
      object-fit: contain;
      width: 100%;
    }
  }

  .ma-ai-text {
    color: rgba(68, 57, 128, 1);
    font-size: 15px;
    line-height: 1.2;
    margin-bottom: 5px;
    text-align: center;
  }

  .ma-tip {
    align-items: center;
    background: linear-gradient(
      90deg,
      rgba(165, 0, 47, 0) 0%,
      rgba(70, 4, 81, 0.7) 50%,
      rgba(63, 0, 14, 0) 100%
    );
    box-sizing: border-box;
    color: rgba(255, 255, 255, 1);
    display: flex;
    font-family: "PingFang SC", "Hiragino Sans GB", sans-serif;
    font-size: 10px;
    font-weight: 600;
    justify-content: center;
    min-height: 28px;
    width: 100%;

    span {
      box-sizing: border-box;
      display: block;
      line-height: 14px;
      text-align: center;
      white-space: normal;
      width: 291px;
    }
  }

  .androidOverlay,
  .iosOverlay {
    align-items: center;
    display: flex;
    justify-content: center;
  }

  .overlayContent {
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: 12px;
    height: 441px;
    padding-top: 380px;
    width: 297px;
  }

  .androidOverlay .overlayContent {
    background-image: url("../../../assets/images/mobile1/androidTip.png");
  }

  .iosOverlay .overlayContent {
    background-image: url("../../../assets/images/mobile1/iosTip.png");
  }

  .confirmBtnBox {
    border-radius: 40px;
    height: 33px;
    margin: 0 auto;
    width: 128px;
  }
}

.downTip {
  border-radius: 10px;
  box-sizing: border-box;
  padding: 18px;
  text-align: center;

  .downTipTitle {
    font-size: 18px;
    margin-bottom: 34px;
  }

  .downTipContent,
  .url,
  .downTipConfirm {
    font-size: 15px;
  }

  .downTipContent {
    white-space: nowrap;
  }

  .url {
    margin-top: 16px;
    text-align: left;
  }

  .downTipConfirm {
    align-items: center;
    background: #5b92ee;
    border-radius: 40px;
    color: #fff;
    display: flex;
    height: 30px;
    justify-content: center;
    margin: 32px auto 0;
    width: 160px;
  }
}

</style>
